import { useProductsFetcherData } from "./useProductsFetcherData";
import { MagentoSortOptions } from "~/modules/catalog/variables/MagentoSortOptions";
import { ProductSortOptionType } from "~/modules/settings/types";

export function useMagentoCatalogData(
  categoryId: MaybeRef<string | undefined>,
  queryVariables: {
    committedQueryVariables: Ref<any>;
  },
  options?: { key?: string },
) {
  const { committedQueryVariables: filters } = queryVariables;

  return useProductsFetcherData(
    computed(() => {
      const magentoFilters = {
        ...unref(filters).filter.selectedFiltersToSearch(),
      };

      const sortOption =
        MagentoSortOptions[unref(filters).sort as ProductSortOptionType];
      const sort =
        sortOption?.field && sortOption?.direction
          ? {
              sort: {
                [sortOption.field]: sortOption.direction,
              },
            }
          : {};

      const categoryFilter = {
        category_uid: magentoFilters.category_uid
          ? magentoFilters.category_uid
          : unref(categoryId)
            ? {
                eq: unref(categoryId)!,
              }
            : {},
      };

      return {
        ...(unref(filters).term
          ? { search: unref(filters).term as string }
          : {}),
        currentPage: unref(filters).page,
        pageSize: unref(filters).size,
        ...sort,
        filter: {
          ...magentoFilters,
          ...categoryFilter,
        },
      };
    }),
    {
      key: options?.key,
      query: "catalogProducts",
    },
  );
}
